import namespace from 'consts:namespace';
import {lazyCustomElements, dataset, classList} from 'nuffjs';

const config = () => {
	document.querySelector('html').classList.add(namespace + '-html--js');

	dataset.setNs(namespace + '-');
	classList.setNs(namespace + '-js-');

	lazyCustomElements.setOptions({
		autodefineAttribute: dataset.attrName('autodefine'),
		autoloadAttribute: dataset.attrName('autoload'),
	});

	// APP:

	lazyCustomElements
		.define(
			'app-filtered-definitions',
			async () => (await import('./app/definitions/filtered-definitions')).FilteredDefinitions
		)
		.define(
			'app-search-visual-controls',
			async () => (await import('./app/search/search-visual-controls')).SearchVisualControls,
			{extends: 'section'}
		)
		.define(
			'app-persistent-toggler',
			async () => (await import('./app/widget/persistent-toggler')).PersistentToggler,
			{extends: 'button'}
		)
		.define(
			'app-filters-dialog',
			async () => (await import('./app/dialog/filters-dialog')).FiltersDialog
		)
		.define('app-project', async () => (await import('./app/navigation/project')).Project)
		.define('app-addresses', async () => (await import('./app/navigation/addresses')).Addresses);

	// CDLX:

	lazyCustomElements
		// MEDIA:
		.define('cdlx-lazy-img', async () => (await import('./cdlx/media/lazy-img')).LazyImg, {
			extends: 'img',
		})
		.define(
			'cdlx-video-player',
			async () => (await import('./cdlx/media/video-player')).VideoPlayer
		)
		.define(
			'cdlx-video-player-cover',
			async () => (await import('./cdlx/media/video-player-cover')).VideoPlayerCover
		)
		.define(
			'cdlx-video-player-bg',
			async () => (await import('./cdlx/media/video-player-bg')).VideoPlayerBg
		)

		// ACTION:
		.define('cdlx-action-', async () => (await import('./cdlx/action/action')).actionMixin, {
			extends: ['button', 'a'],
		})
		.define('cdlx-toggler-', async () => (await import('./cdlx/action/toggler')).togglerMixin, {
			extends: ['button', 'a'],
		})
		.define(
			'cdlx-dialog-toggler-',
			async () => (await import('./cdlx/action/dialog-toggler')).dialogTogglerMixin,
			{extends: ['button', 'a']}
		)

		// DIALOG:
		.define('cdlx-dialog', async () => (await import('./cdlx/dialog/dialog')).Dialog)

		// WIDGET:
		.define('cdlx-collapsable', async () =>
			(await import('./cdlx/widget/collapsable')).Collapsable(HTMLElement)
		)

		.define(
			'cdlx-collapsable-',
			async () => (await import('./cdlx/widget/collapsable-mixin')).collapsableMixin,
			{extends: '*'}
		)
		.define('cdlx-collapsable', async () => (await import('./cdlx/widget/collapsable')).Collapsable)
		.define('cdlx-accordion', async () => (await import('./cdlx/widget/accordion')).Accordion)
		.define(
			'cdlx-contextual-menu-toggler',
			async () => (await import('./cdlx/widget/contextual-menu-toggler')).ContextualMenuToggler,
			{extends: 'button'}
		)

		// SLIDESHOW:
		.define('cdlx-slideshow', async () => (await import('./cdlx/slideshow/slideshow')).Slideshow)
		.define('cdlx-slideshow-slide', async () => (await import('./cdlx/slideshow/slide')).Slide)
		.define(
			'cdlx-slideshow-navigation',
			async () => (await import('./cdlx/slideshow/slideshow-navigation')).SlideshowNavigation
		)
		.define(
			'cdlx-gesture-aware-link',
			async () => (await import('./cdlx/widget/gesture-aware-link')).GestureAwareLink,
			{extends: 'a'}
		)

		// TRACKERS:
		.define('cdlx-trackers', async () => (await import('./cdlx/trackers/trackers')).Trackers)

		// FORM:
		.define('cdlx-text-field', async () => (await import('./cdlx/form/text-field')).TextField)
		.define(
			'cdlx-textarea-field',
			async () => (await import('./cdlx/form/textarea-field')).TextareaField
		)
		.define(
			'cdlx-password-field',
			async () => (await import('./cdlx/form/password-field')).PasswordField
		)
		.define('cdlx-search-field', async () => (await import('./cdlx/form/search-field')).SearchField)
		.define('cdlx-email-field', async () => (await import('./cdlx/form/email-field')).EmailField)
		.define(
			'cdlx-checkbox-field',
			async () => (await import('./cdlx/form/checkbox-field')).CheckboxField
		)
		.define('cdlx-radio-field', async () => (await import('./cdlx/form/radio-field')).RadioField)
		.define('cdlx-select-field', async () => (await import('./cdlx/form/select-field')).SelectField)
		.define('cdlx-hidden-field', async () => (await import('./cdlx/form/hidden-field')).HiddenField)
		.define('cdlx-date-field', async () => (await import('./cdlx/form/date-field')).DateField)
		.define(
			'cdlx-datetime-field',
			async () => (await import('./cdlx/form/datetime-field')).DatetimeField
		)
		.define('cdlx-group-field', async () => (await import('./cdlx/form/group-field')).GroupField)
		.define('cdlx-array-field', async () => (await import('./cdlx/form/array-field')).ArrayField)
		.define(
			'cdlx-options-field',
			async () => (await import('./cdlx/form/options-field')).OptionsField
		)

		.define('cdlx-form', async () => (await import('./cdlx/form/form')).Form, {extends: 'form'})

		// PANKOW:
		.define('cdlx-pankow-form', async () => (await import('./cdlx/pankow/pankow-form')).PankowForm)

		// HEADER:
		.define(
			'cdlx-collapsable-header',
			async () => (await import('./cdlx/header/collapsable-header')).CollapsableHeader,
			{extends: 'header'}
		)
		.define(
			'cdlx-header-with-search',
			async () => (await import('./cdlx/header/header-with-search')).HeaderWithSearch,
			{extends: 'header'}
		)

		// SEARCH:
		.define('cdlx-search', async () => (await import('./cdlx/search/search')).Search)

		// CALENDAR:
		.define('cdlx-calendar', async () => (await import('./cdlx/calendar/calendar')).Calendar)

		// BOOKING:
		.define(
			'cdlx-booking-form',
			async () => (await import('./cdlx/booking/booking-form')).BookingForm
		);
};

export {config};
